export class TextMeasurer {
    static getInstance(fontSize, fontFamily, fontWeight) {
        if (TextMeasurer.instance) {
            TextMeasurer.instance.config(fontSize, fontFamily, fontWeight);
            return TextMeasurer.instance;
        }
        return (TextMeasurer.instance = new TextMeasurer(fontSize, fontFamily, fontWeight));
    }
    constructor(fontSize, fontFamily, fontWeight) {
        this.fontSize = 14;
        this.fontFamily = '';
        this.fontWeight = 'normal';
        this.cacheName = '';
        this.cache = new Map();
        this.config(fontSize, fontFamily, fontWeight);
    }
    config(fontSize, fontFamily, fontWeight) {
        this.fontSize = fontSize ?? this.fontSize;
        this.fontFamily = fontFamily ?? this.fontFamily;
        this.fontWeight = fontWeight ?? this.fontWeight;
        this.cacheName = [this.fontSize, this.fontFamily, this.fontWeight, ''].join(';');
        if (!this.ctx)
            return;
        this.ctx.font = `${this.fontWeight} ${this.fontSize}px ${this.fontFamily}`;
    }
    initCtx() {
        if (this.ctx)
            return;
        try {
            this.ctx = document.createElement('canvas').getContext('2d') ?? undefined;
        }
        catch (err) {
            //
        }
        this.config();
    }
    calc(v, useCache = false) {
        this.initCtx();
        const name = this.cacheName + v;
        if (this.cache.has(name)) {
            return this.cache.get(name) ?? 0;
        }
        if (!this.ctx)
            return 0;
        const { width } = this.ctx.measureText(v);
        useCache && this.cache.set(name, width);
        return width;
    }
}
TextMeasurer.instance = undefined;
